import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/kfmApi";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Passwords don't match.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      toast.success(data.message || "Password updated.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-[#07090E] px-6">
      <div className="w-full max-w-sm animate-in fade-in slide-in-from-bottom-4 duration-700">
        <h1 className="text-3xl text-white text-center mb-2">Set a new password</h1>
        <p className="text-sm text-slate-400 text-center mb-8">Choose something you'll remember.</p>

        {!token && <p className="text-sm text-red-500 text-center mb-4">Missing or invalid reset link.</p>}

        <form onSubmit={submit} className="space-y-4">
          <Input
            data-testid="reset-password"
            type="password"
            placeholder="New password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="h-12 rounded-xl border-[#29344D] bg-[#0E131F]"
          />
          <Input
            data-testid="reset-confirm"
            type="password"
            placeholder="Confirm password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            className="h-12 rounded-xl border-[#29344D] bg-[#0E131F]"
          />
          {error && <p data-testid="reset-error" className="text-sm text-red-500 text-center">{error}</p>}
          <Button
            data-testid="reset-submit"
            type="submit"
            disabled={loading || !token}
            className="w-full h-12 rounded-full bg-[#00E5FF] hover:bg-[#00B8CC] text-[#07090E] text-base font-medium"
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Update password"}
          </Button>
        </form>
      </div>
    </div>
  );
}
